import React from 'react';

const Support = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>サポート情報</h1>
      <p>
        何かトラブルや質問があれば、全ての問い合わせは以下のサポートメールアドレスまでご連絡ください：
        <br />
        <a href="mailto:bassfishingappsup@gmail.com">bassfishingappsup@gmail.com</a>
      </p>
      <p>
        公式の最新情報はアプリ内公式アカウント(@basstomo)もしくは以下のX公式アカウントリンクからご参照ください：
        <br />
        <a href="https://twitter.com/oimobass" target="_blank" rel="noopener noreferrer">
          https://twitter.com/oimobass
        </a>
      </p>
    </div>
  );
};

export default Support;
